import { LayoutConfig } from "../sampleConfig";
import { changeType } from "../store/StateManager";
import { DomHelper } from "../utlis/DomHelper";

export interface IStateChangeInfo {
  targetEl?: HTMLElement;
  sectionIds?: string[];
  state: LayoutConfig;
  changeType: string;
  zoomValue?:number;
  multiplier?:number;
//   oldState:LayoutConfig
}

export class UndoManager {
  private static instance: UndoManager;
  private undoStack: IStateChangeInfo[] = [];
  private redoStack: IStateChangeInfo[] = [];
  private maxStackSize: number = 50;

  private constructor() {}

  public static getInstance(): UndoManager {
    if (!UndoManager.instance) {
      UndoManager.instance = new UndoManager();
    }
    return UndoManager.instance;
  }

  public pushState(state: IStateChangeInfo): void {

    this.undoStack.push(JSON.parse(JSON.stringify(state)));
    this.redoStack = []; // Clear redo stack when new action is performed

    // Maintain stack size limit
    if (this.undoStack.length > this.maxStackSize) {
      this.undoStack.shift();
    }
  }

  public peekUndo():IStateChangeInfo | null{
    if(this.undoStack.length<=0) return null;
    return DomHelper.cloneObj(this.undoStack[this.undoStack.length-1])
  }
  public peekRedo():IStateChangeInfo| null{
    if(this.redoStack.length<=0) return null;
    return DomHelper.cloneObj(this.redoStack[this.redoStack.length-1])
  }

  public undo(): IStateChangeInfo | null {
    if (this.undoStack.length === 0) return null;

    const state =JSON.parse(JSON.stringify(this.undoStack.pop()));
    this.redoStack.push(JSON.parse(JSON.stringify(state)));
    return state;
  }

  public redo(): IStateChangeInfo | null {
    if (this.redoStack.length === 0) return null;

    const state = JSON.parse(JSON.stringify(this.redoStack.pop()));
    this.undoStack.push(state);
    return state;
  }

  public clearHistory(): void {
    this.undoStack = [];
    this.redoStack = [];
  }

  public canUndo(): boolean {
    return this.undoStack.length > 0;
  }

  public canRedo(): boolean {
    return this.redoStack.length > 0;
  }
}
